export const RESET = 'EXSBOPERATION_LIST_RESET'
export const SET_ITEMS = 'EXSBOPERATION_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBOPERATION_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBOPERATION_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBOPERATION_LIST_TOGGLE_LOADING'
